import React, { useEffect, useRef, useState } from 'react';
import { Translate, translate } from 'react-jhipster';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, IconButton } from '@mui/material';
import { Button, Col, Form, Input, Label, Row, Spinner } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';
import { DialogProps } from '@mui/material/Dialog';
import { toast } from 'react-toastify';

export const AmountTransferDocUploadDialog = ({
  openDocUploadDialog,
  handleCloseDocUploadDialog,
  onFileSelected,
  inputStyle,
  labelStyle,
  initialFileName = '',
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedFileName, setSelectedFileName] = useState('');

  const shortenFileName = (name: string, maxLength = 50) => {
    if (name.length <= maxLength) return name;
    const ext = name.split('.').pop();
    const base = name.replace(`.${ext}`, '');
    return base.substring(0, maxLength - ext.length - 5) + `...${ext}`;
  };

  const handleFileChange = e => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedFile(file);
      setSelectedFileName(shortenFileName(file.name));
    }
  };

  const handleClose = () => {
    // Reset local state when closing without submitting
    setSelectedFile(null);
    setSelectedFileName('');
    if (fileInputRef.current) fileInputRef.current.value = '';
    handleCloseDocUploadDialog();
  };

  const handleSubmit = () => {
    if (selectedFile) {
      // Pass the ACTUAL file object and its name to parent
      onFileSelected(selectedFile, selectedFile.name);
      // Close dialog - parent now has the file
      handleCloseDocUploadDialog();
    } else {
      toast.error('Please select a file first');
    }
  };

  // Reset dialog when it opens
  useEffect(() => {
    if (openDocUploadDialog) {
      // Always clear local selection when dialog opens
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';

      // Show existing filename from parent if it exists
      if (initialFileName) {
        setSelectedFileName(shortenFileName(initialFileName));
      } else {
        setSelectedFileName('');
      }
    }
  }, [openDocUploadDialog, initialFileName]);

  return (
    <Dialog
      open={openDocUploadDialog}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="amount-transfer-doc-upload-dialog-title"
    >
      <DialogTitle style={{ fontWeight: 'bold' }}>Upload Document</DialogTitle>
      <DialogContent>
        <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <Row className="justify-content-center">
          <div>
            <Label>{translate('home.table.transferSlip')}</Label>
            <br />
            <label htmlFor="transfer-slip-upload" style={labelStyle}>
              {translate('comexApp.quotation.uploadFile.btnUploadFile')}
            </label>
            &nbsp;
            <span>{selectedFileName === '' ? translate('comexApp.quotation.uploadFile.noFileChoosen') : selectedFileName}</span>
            <Input
              innerRef={fileInputRef}
              type="file"
              accept=".pdf, .jpg, .jpeg, .png"
              id="transfer-slip-upload"
              style={inputStyle}
              onChange={handleFileChange}
            />
            <br />
            <label style={{ fontSize: '12px', color: 'gray' }}>Supported file formats: PDF, JPG, JPEG, PNG</label>
            &nbsp;
          </div>
        </Row>
      </DialogContent>
      <DialogActions className="mx-3 mb-3">
        <Button onClick={handleClose}>{translate('comexApp.quotation.cancelBtnLabel')}</Button>
        &nbsp;
        <Button color="primary" onClick={handleSubmit} disabled={!selectedFile}>
          <Translate contentKey="comexApp.quotation.submit">Submit</Translate>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
